






























import { Vue, Component } from "vue-property-decorator";
import download from "downloadjs";
import pdf from "vue-pdf";

import RequestHandler from "@/assets/ts/requestHandler";
const requestHandler = new RequestHandler();

@Component({
  components: {
    pdf
  }
})
export default class Receipt extends Vue {
  displayDialog = false;
  base64PDF = "";
  paymentID = "";

  public async receipt(paymentID: string, type = "display") {
    this.paymentID = paymentID;
    try {
      const res: any = await requestHandler.getReceipt(
        {
          paymentId: paymentID,
          service: this.$store.getters.userInfo.Service,
          countyId: this.$store.getters.userInfo.CountyID
        },
        ["display", "print"].includes(type)
      );
      switch (type) {
        case "display":
          this.base64PDF =
            "data:application/pdf;base64," +
            btoa(
              new Uint8Array(res.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            );

          this.displayDialog = true;
          break;

        case "download":
          download(
            res.data,
            "Receipt-" + paymentID,
            res.headers["content-type"]
          );
          break;
        case "print":
          await requestHandler.setHubConfigs();
          if (
            this.$store.getters.hubAppConfig.printSettings != undefined &&
            this.$store.getters.hubAppConfig.printSettings[0] != undefined &&
            this.$store.getters.hubAppConfig.printSettings[0].printer != ""
          ) {
            try {
              await requestHandler.printPDF({
                pdf: btoa(
                  new Uint8Array(res.data).reduce(
                    (data, byte) => data + String.fromCharCode(byte),
                    ""
                  )
                ),
                index: 0
              });
              this.$root.$emit("snackbar-message", {
                text: "Transaction finished.",
                color: "green"
              });
            } catch (e) {
              this.receipt(paymentID, "display");
            }
          } else {
            this.receipt(paymentID, "display");
          }
          break;
      }
    } catch (e) {
      console.error(e);
      this.$root.$emit("snackbar-message", {
        text: "Unable to load receipt.",
        color: "red"
      });
    }
  }
}
